/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Format_P1Inputs */

const en_wc_tut_format_p1 = /** @type {(inputs: Wc_Tut_Format_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select text and use the Home tab, or the usual shortcuts, to change font, size, colour, bold, italic and underline. Format Painter copies formatting from one place to another.`)
};

/**
* | output |
* | --- |
* | "Select text and use the Home tab, or the usual shortcuts, to change font, size, colour, bold, italic and underline. Format Painter copies formatting from one..." |
*
* @param {Wc_Tut_Format_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_format_p1 = /** @type {((inputs?: Wc_Tut_Format_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Format_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_format_p1(inputs)
});
export { wc_tut_format_p1 as "wc.tut.format.p1" }